import coreConfig from '../../app-config.json';

interface Config {
  ENV: 'master' | 'sandbox' | 'dev';
  SSL_ENABLED: boolean;
  GRAPHQL_DOMAIN: string;
  REST_API_URL: string;
}

export const config: Config = coreConfig as Config;